import SiteNav from "../components/SiteNav";
import SiteFooter from "../components/SiteFooter";
import BackBar from "../components/BackBar";
import { Link } from "react-router-dom";
import { CheckCircle2, Shield, Users, Lock, Globe, Mail } from "lucide-react";
import Brand from "../components/Brand";

const TRUTHS = [
  {
    Icon: Globe,
    title: "Yes, you start on faitharama.com/u/yourname",
    body: "That's your starter address — fast, free, and tied to the shared brand authority of the whole site (we'd rather YOU rank than fight 1.7 billion other websites for attention). Want your own custom domain too? We're standing up a Namecheap reseller storefront — buy your domain right here, point it at your page, and you're off. Shared brand for reach, your domain for swagger. Both, not either-or."
  },
  {
    Icon: CheckCircle2,
    title: "Yes, you can leave anytime",
    body: "Your contacts and content are yours. One click in the dashboard exports everything as CSV / PDF. No lock-in, no held data, no hostage tactics. We earn your stay every month — we don't trap it."
  },
  {
    Icon: Users,
    title: "Yes, we're a family — and family doesn't steal from family",
    body: "If we catch any member knowingly importing another member's contact list, copying their funnel content, or solicit-poaching their followers — that account is canceled. Period. No refund, no comeback. We protect your audience the same way we protect everyone else's."
  },
  {
    Icon: Mail,
    title: "Yes, every email goes out from faitharama.com",
    body: "When the platform sends emails on your behalf, they fly from our domain — with YOUR name in the From line and YOUR affiliate link in every footer. This protects deliverability for the whole family. One bad sender hurts us all; one good one lifts us all."
  },
  {
    Icon: Shield,
    title: "Yes, we're upfront about money",
    body: "$49/mo covers EVERYTHING on the platform. The only paid extras: Mike's book and Christian merchandise. The commission rule is 50/50 — Faitharama splits HALF of whatever we earn with the member who made the sale. So if a brand pays us 10% on a sale, you get 5%. If they pay us 40%, you get 20%. Same math every time: half ours, half yours. Goli Gummies is the one outlier: you sign up to Goli directly, so you keep 100% of those commissions yourself. That's the math."
  },
  {
    Icon: Lock,
    title: "Yes, we'll say no to bad behavior",
    body: "We reserve the right to cancel any account that violates our values — hate speech, predatory marketing, doctrinal abuse, or harm to other members. We're not a free-for-all. We're a safe house for Christian entrepreneurs."
  },
];

export default function HonestTruth() {
  return (
    <div className="min-h-screen bg-ivory" data-testid="honest-truth-page">
      <SiteNav />
      <BackBar />
      <section className="max-w-4xl mx-auto px-6 md:px-8 py-12">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 bg-[#0F172A] text-[#F39A1F] px-3 py-1 rounded-full text-[10px] tracking-wider-cap font-bold uppercase mb-3">★ THE HONEST TRUTH ★</div>
          <h1 className="font-serif-display text-4xl md:text-6xl text-red-wine uppercase leading-tight">No Spin. No Sales Talk.</h1>
          <div className="divider-gold"></div>
          <p className="text-base md:text-lg text-foreground max-w-2xl mx-auto">Reviewers will eventually pick <Brand/> apart looking for what we hide. We hide nothing. Here's the platform — warts and all — built on the idea that <em>plain talk wins trust</em>.</p>
        </div>

        <div className="space-y-4">
          {TRUTHS.map((t, i) => (
            <article key={i} data-testid={`truth-${i}`} className="rounded-2xl border-2 border-foreground/15 bg-white p-6 hover:border-[#F39A1F]/50 transition">
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-full bg-white border-2 border-[#F39A1F] flex items-center justify-center shrink-0">
                  <t.Icon className="w-5 h-5 text-red-wine" strokeWidth={2.25}/>
                </div>
                <div className="flex-1">
                  <h2 className="font-serif-display text-xl md:text-2xl text-red-wine uppercase leading-tight">{t.title}</h2>
                  <p className="text-foreground mt-2 text-base leading-relaxed">{t.body}</p>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-10 rounded-2xl bg-gradient-to-r from-[#0F172A] to-[#2A2521] text-white p-7 text-center shadow-2xl border-2 border-[#F39A1F]/40">
          <div className="text-[10px] tracking-wider-cap font-bold text-[#F39A1F]">★ ONE LAST TRUTH</div>
          <h3 className="font-serif-display text-2xl md:text-3xl uppercase mt-1">It's easier doing this as a team.</h3>
          <p className="text-white/85 mt-2 max-w-2xl mx-auto">If you&apos;re tired of building alone — coach, teacher, author, homeschool family, small business owner — we built Faitharama for you. 7-day free trial. $49 unlocks everything when you&apos;re ready.</p>
          <div className="mt-5 flex flex-wrap justify-center gap-3">
            <Link to="/signup?plan=free" className="bg-[#F39A1F] text-[#0F172A] px-6 py-3 rounded-md font-bold uppercase tracking-wider-cap text-sm hover:bg-white transition" data-testid="truth-cta-free">Claim My Free Page</Link>
            <Link to="/pricing" className="bg-transparent border-2 border-[#F39A1F] text-[#F39A1F] hover:bg-[#F39A1F] hover:text-[#0F172A] px-6 py-3 rounded-md font-bold uppercase tracking-wider-cap text-sm transition" data-testid="truth-cta-pricing">See $49 All Access</Link>
          </div>
        </div>
      </section>
      <SiteFooter />
    </div>
  );
}
